export const getLeadFormInitValues = (formData, defaultLoanType, defaultAmount, defaultTerm, defaultCurrency, defaultBank, fields, state) => {

    const initValues = {
        loanType: '',
        amount: '',
        currency: '',
        term: '',
        income: '',
        otherInstallments: '',
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        CNP: '',
        county: [],
        city: [],
        branch:[],
        birthdate: '',
        creditBureauDelay: '',
        totalEmployment: '',
        currentEmployment: '',
        financer: ''
    };
   

    //defaultValues
    const {product, financial, contact} = fields; 
    for (const [key, field] of Object.entries(product)) {
        if (field.defaultValue.length>0) initValues[key] = field.defaultValue;
    }

    for (const [key, field] of Object.entries(financial)) {
        if (field.defaultValue.length>0) initValues[key] = field.defaultValue;
    }

    for (const [key, field] of Object.entries(contact)) {
        
        if (field.defaultValue.length>0) {
            if (key == 'city' || key == 'county') {
                initValues[key] = [field.defaultValue];
            } else {
                initValues[key] = field.defaultValue;
            }
        } 
    }


    //query string
    if (defaultAmount) initValues.amount = defaultAmount;
    if (defaultTerm) initValues.term = defaultTerm;
    if (defaultCurrency) initValues.currency = defaultCurrency;
    if (defaultLoanType) initValues.loanType = decodeURI(defaultLoanType);
    if (defaultBank) initValues.financer = decodeURI(defaultBank);

    //tracking
    if (formData) {
        for (const [key, value] of Object.entries(formData)) {
            if (initValues.hasOwnProperty(key)) {
                if (key == 'city' || key == 'county' || key=='branch') {
                    initValues[key] = [value];
                } else {
                    initValues[key] = value;
                }
            }
        }
    }

    //state
  
    if (state) {
        for( const [key, val] of Object.entries(state)) {
            if (val && val.length>0) {
                if (key=='county') {
                    let options = fields.contact.hasOwnProperty('county') ? fields.contact.county.options : [];
                    if (options.includes(val[0])) {
                        initValues[key] = val;
                    }
                } else {
                    initValues[key] = val;
                }
            }
        }
    }
  
    return initValues;
}

export const getPayloadLeadState = (formData) => {
    let payload = {
        loanProfile: {},
    };

    const basicFields = ['firstName', 'lastName', 'email', 'phone', 'CNP', 'city', 'county'];
    const loanProfileFields = ['income', 'otherInstallments', 'birthdate', 'creditBureauDelay', 'totalEmployment', 'currentEmployment'];

    for (const [key, value] of formData.entries() ) {
        
       if (basicFields.includes(key)) {
           payload[key] = value;
       } else if (loanProfileFields.includes(key)) {
           if (key == 'otherInstallments') {
               payload.loanProfile.currentPayments = value;
           } else {
               payload.loanProfile[key] = value;
           }
       }
    }
    return payload;
} 

export const getFormFromState = (user) => {
    let formData = {
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        phone: user.phone,
        CNP: user.CNP,
        income: user.loanProfile.income,
        otherInstallments: user.loanProfile.currentPayments,
        birthdate: user.loanProfile.birthdate,
        creditBureauDelay: user.loanProfile.creditBureauDelay,
        totalEmployment: user.loanProfile.totalEmployment,
        currentEmployment: user.loanProfile.currentEmployment,
    };
    if (user.county) {
        formData.county = [user.county];
    }
    if (user.city) {
        formData.city = [user.city];
    }
   
    return formData;
}

export const getProductTypeLead = (product, type) => {
    
    const options = {
        personalLoans: 'Credit nevoi personale',
        mortgageLoans: 'Credit imobiliar',
        refinanceLoans: 'Refinanțare cu ipotecă',
        firstHomeLoans: 'Credit Noua Casă',
        autoLoans: 'Credit auto',
        homeEquityLoans: 'Credit de nevoi cu ipotecă',
        deposits: 'Depozit',
        creditCard: 'Card de credit',
        leasing: 'Leasing auto',
        paydayLoan: 'Credit rapid',
    };
    let result;

    if (options.hasOwnProperty(product)) {
        result = options[product];
    }

    if (product == 'refinanceLoans' && type=='refinance personal loan') {
        result = 'Refinanțare fără garanții';
    }
    if (product == 'personalLoans' && type=='home equity loan') {
        result = 'Credit de nevoi cu ipotecă';
    }

    return encodeURIComponent(result);
}

export const getLeadQueryString = (product, type, amount, currency, term) => {
    let result = '';

    if (type && product) {
        result += `${result.length>0 ? '&' : ''}type=${getProductTypeLead(product, type)}`;
    }
    if (amount) {
        result += (result.length>0 ? '&' : '') + 'amount=' + amount;
    }
    if (term) {
        result += (result.length>0 ? '&' : '') + 'term=' + (product=='leasing' ? term : term/12);
    }
    if (currency) {
        result += (result.length>0 ? '&' : '') + 'currency=' + currency;
    }
    return result;
}